import { render, staticRenderFns } from "./WebFormTabReadOnly.vue?vue&type=template&id=3dff44ba&"
import script from "./WebFormTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./WebFormTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports